import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageCircle, Send } from "lucide-react";
import { toast } from "@/hooks/use-toast";
import { messageDistributionService } from "@/services/messageDistributionService";

const AdminWelcomeMessageSender = () => {
  const [isSending, setIsSending] = useState(false);

  const handleSendWelcomeMessage = async () => {
    setIsSending(true);
    
    try {
      const result = await messageDistributionService.sendAdminWelcomeMessage();
      
      if (result.success) {
        toast({
          title: "Success!",
          description: result.message,
        });
      } else {
        toast({
          title: "Error",
          description: result.message,
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error('Error sending welcome message:', error);
      toast({
        title: "Error",
        description: "Failed to send welcome message",
        variant: "destructive",
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Send className="w-5 h-5 text-electric-violet" />
          Admin Welcome Message
        </CardTitle>
        <CardDescription>
          Send a welcome message from the admin to all users
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="p-4 bg-electric-violet/10 rounded-lg border border-electric-violet/20">
            <h4 className="font-medium text-electric-violet mb-2 flex items-center gap-2">
              <MessageCircle className="w-4 h-4" />
              Message Content:
            </h4>
            <p className="text-sm text-ice-white/80 italic">
              "Welcome to ALPHA, this is a test message and we wish you all a good hunt!"
            </p>
          </div>
          
          <div className="p-3 bg-ice-white/5 rounded-lg">
            <h5 className="text-sm font-medium text-ice-white mb-1">What this does:</h5>
            <ul className="text-xs text-ice-white/70 space-y-1">
              <li>• Sends the welcome message from the admin user to all visible users</li>
              <li>• Creates new conversation threads for testing</li>
              <li>• Tests the real-time messaging system</li>
              <li>• Verifies message delivery and notifications</li>
            </ul>
          </div>
          
          <Button
            onClick={handleSendWelcomeMessage}
            disabled={isSending}
            className="w-full bg-electric-violet hover:bg-electric-violet/90 text-ice-white"
            size="lg"
          >
            {isSending ? (
              <>
                <div className="animate-spin w-4 h-4 mr-2 border-2 border-white border-t-transparent rounded-full"></div>
                Sending Welcome Message...
              </>
            ) : (
              <>
                <Send className="w-4 h-4 mr-2" />
                Send Welcome Message to All Users
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdminWelcomeMessageSender;